import { ISorter, ISorterConfig, ISorterExpression, SorterConfig } from "pbc.types";

export interface IKundenGruppeSorter extends ISorter {
  id?: ISorterExpression;
  name?: ISorterExpression;
  beschreibung?: ISorterExpression;
}

export const KundenGruppeSorterConfig: ISorterConfig = [
  SorterConfig('id', 'Id'),
  SorterConfig('name', 'Name'),
  SorterConfig('beschreibung', 'Beschreibung')
];
